<div>
  <div class="test" style="text-align: center">
    <div class="col-sm-12">
      <h3>{{title}}</h3>
    </div>
    <div class="col-sm-12" *ngIf="icone === ''">
      <h5>{{message}}</h5>
    </div>
    <div class="col-sm-12" *ngIf="icone !== ''">
      <mat-icon class="col-sm-2" style="bottom: auto;" [color]="icon_color">{{icone}}</mat-icon>
      <div class="col-sm-10">
        <h5>{{message}}</h5>
      </div>
    </div>
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    <div class="col-sm-6" style="margin-left: 25%; margin-top: 20px; margin-bottom: 20px;" *ngIf="type === 'livrer'">
      <mat-form-field class="full-width">
          <mat-label>Date de livraison</mat-label>
          <input required matInput  [matDatepicker]="pickerDLivr"  [matDatepickerFilter]="weekendsDatesFilter" name="nth-date-bc" 
          [min]="minDate" [max]="maxDate" [(ngModel)]="dLivraison" [disabled]="this.data.disabled === true ? true : false">
          <mat-datepicker-toggle matSuffix [for]="pickerDLivr"></mat-datepicker-toggle>
          <mat-datepicker #pickerDLivr></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    <div class="row">
      <div class="col-sm-6" style="margin-top: 40px;">
        <button mat-raised-button color="default" (click)="onModalCancel()">Non</button>
      </div>
      <div class="col-sm-6" style="margin-top: 40px;" >
        <button mat-raised-button [color]="color" (click)="onModalConfirm()" >
          <div *ngIf="type !== 'livrer'"> Oui </div>
          <div *ngIf="type === 'livrer'"> Livrer tout</div>
        </button>
      </div>
    </div>
  </div>
</div>